export type AppRole =
    | "super-admin"
    | "owner"
    | "compliance"
    | "finance"
    | "client"
    | "supplier"
    | "depositor";

export const normalizeRole = (raw?: string | null): AppRole | null => {
    if (!raw) return null;
    const key = raw.trim().toLowerCase();

    if (key === "super admin"  || key === "super-admin" || key === "superadmin") return "super-admin";
    if (key === "owner") return "owner";
    if (key === "compliance" || key.includes("compliance")) return "compliance";
    if (key === "finance" || key.includes("finance"))       return "finance";
    if (key === "supplier" || key.includes("supplier"))     return "supplier";
    if (key === "client" || key.includes("client"))         return "client";
    if (key === "depositor")                                return "depositor";

    return null;
};

export type RouteKey =
    // ---- common
    | "home"

    // ---- super-admin
    | "admin-users"
    | "admin-organizations"
    | "admin-companies"

    // ---- client/owner shared listings
    | "clients"
    | "client-deposits"
    | "purchases"
    | "client-invoices"
    | "suppliers"
    | "profit"
    | "quotations"
    | "compliance"
    | "balance"
    | "statement"
    | "assets"
    | "credits"
    | "deposit-accounts"
    | "receipts"
    | "supplier-receipts"
    | "supplier-payments"
    | "repasses"
    | "envios"

    // ---- client (only)
    | "wallets"
    | "user-accounts"
    | "client-deposits-self"
    | "profile"
    | "listar-carteiras"

    // ---- supplier (only)
    | "supplier-deliveries"
    | "supplier-history";


export const PERMISSIONS: Record<AppRole, RouteKey[] | "*"> = {
    "super-admin": "*",

    "owner": [
        "home",
        "clients", "client-deposits", "purchases", "client-invoices", "envios",
        "suppliers", "supplier-receipts", "supplier-payments", "repasses",
        "profit", "credits", "balance", "statement", "assets",
        "quotations", "compliance",
        "receipts",
        "deposit-accounts",
    ],

    "compliance": [
        "home",
        "compliance",
    ],

    "finance": [
        "home",
        "profit", "balance", "statement",
    ],

    "client": [
        "home",
        "wallets",
        "user-accounts",
        "client-deposits-self",
        "profile",
        "listar-carteiras",
    ],

    "supplier": [
        "home",
        "supplier-deliveries",
        "supplier-history",
        "profile",
    ],

    "depositor": [
        "home",
        "profile",
    ],
};


export const PERMISSIONS_DENY: Partial<Record<AppRole, RouteKey[]>> = {
    "super-admin": [
        // Acoes para Clientes
        "clients", "purchases", "credits", "envios",
        // Acoes para Fornecedores
        "suppliers", "supplier-receipts", "supplier-payments", "repasses",
        // Acoes Internas
        "profit", "balance", "assets", "receipts", "compliance", "deposit-accounts",
    ],
};

export const canAccess = (role: AppRole | null, key: RouteKey): boolean => {
    if (!role) return false;
    if (PERMISSIONS_DENY[role]?.includes(key)) return false;
    const allowed = PERMISSIONS[role];
    if (allowed === "*") return true;
    return allowed.includes(key);
};

export const DEFAULT_HOME: Record<AppRole, string> = {
    "super-admin": "/",
    "owner":       "/",
    "compliance":  "/",
    "finance":     "/",
    "client":      "/",
    "supplier":    "/",
    "depositor":   "/",
};

export const ROLE_LABEL: Record<AppRole, string> = {
    "super-admin": "Super Admin",
    "owner":       "Organização",
    "compliance":  "Compliance",
    "finance":     "Financeiro",
    "client":      "Cliente",
    "supplier":    "Fornecedor",
    "depositor":   "Depositante",
};
